
export const commonFormFields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000, },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000, },
    {
        label: "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this procedure",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000, },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000, },
];

// constants/c4DistanceTravelledFields.js
export const c41Fields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
    {
        label: "Description of procedures (including recording and managing distance information. A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Name of person or position responsible for this procedure", name: "responsiblePersonOrPosition", maxLength: 1000 },
    { label: "Data sources", name: "dataSources", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 }
];

export const c42Fields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
    {
        label: "Description of procedure (including recording and managing distance and winter conditions information. A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Name of person or position responsible for this procedure", name: "responsiblePersonOrPosition", maxLength: 1000 },
    { label: "Data sources", name: "dataSources", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 }
];

// constants/C3ListOfVoyagesFields.js
export const c3Fields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
    {
        label:
            "Description of procedures (including recording voyages, monitoring voyages, etc. A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Data sources", name: "dataSources", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 },
];

export const cSectionFormFields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000, },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000, },
    {
        label: "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this procedure",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Formulae and data sources",
        name: "formulaeAndDataSources",
        maxLength: 1000,
    },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000, },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000, },
];

export const c61SectionFormFields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000, },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000, },
    {
        label: "Description of procedure (including recording and managing port departure and arrival information. A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this procedure",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Formulae and data sources",
        name: "formulaeAndDataSources",
        maxLength: 1000,
    },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000, },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000, },
];

export const c62SectionFormFields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000, },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000, },
    {
        label: "Description of procedure (including recording and managing port departure and arrival and winter conditions information. A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this procedure",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Formulae and data sources",
        name: "formulaeAndDataSources",
        maxLength: 1000,
    },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000, },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000, },
];

export const c29SectionFormFields = [
    {
        label: "Applied allocation method according to EN 16258",
        name: "allocationMethod",
        type: "dropdown"
    },
    {
        label: "Description of method to determine the mass of freight and passengers including the possible use of default values for the weight of cargo units/lane meters (if mass method is used)",
        name: "massFreight",
        maxLength: 4000,
    },
    {
        label: "Description of method to determine the deck area assigned to freight and passengers including the consideration of hanging decks and of passenger cars on freight decks (if area method is used)",
        name: "deckArea",
        maxLength: 4000,
    },
    {
        label: "Split of fuel consumption (in %) into freight and passenger part (if area method is used only)",
        name: "fuelConsumptionSplit",
        maxLength: 1000,
    },
    {
        label: "Name of person or position responsible for this method",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Formulae and data sources",
        name: "dataSources",
        maxLength: 1000,
    },
    {
        label: "Location where records are kept",
        name: "recordLocation",
        maxLength: 1000,
    },
    {
        label: "Name of IT system used (where applicable)",
        name: "itSystemName",
        maxLength: 1000,
    },
]

export const D1GhgAndFuelconsumptionColumnsData = [
    {
        label: "Back-up monitoring method",
        name: "backupMonitoringMethod",
        type: "dropdown"
    },
    {
        label: "Formulae used",
        name: "formulaeUsed",
        maxLength: 4000,
    },
    {
        label: "Description of method to estimate greenhouse gas emissions and fuel consumption",
        name: "methodDescription",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this method",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Data sources",
        name: "dataSources",
        maxLength: 1000,
    },
    {
        label: "Location where records are kept",
        name: "recordLocation",
        maxLength: 1000,
    },
    {
        label: "Name of IT system used (where applicable)",
        name: "itSystemName",
        maxLength: 1000,
    }
]

export const DCommonTableLabel = [
    {
        label: "Formulae used",
        name: "formulaeUsed",
        maxLength: 4000,
    },
    {
        label: "Description of method to treat data gaps",
        name: "methodDescription",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this method",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Data sources",
        name: "dataSources",
        maxLength: 1000,
    },
    {
        label: "Location where records are kept",
        name: "recordLocation",
        maxLength: 1000,
    },
    {
        label: "Name of IT system used (where applicable)",
        name: "itSystemName",
        maxLength: 1000,
    }
]

export const C1Column = [
    {
        label: "Minimum number of expected voyages per reporting period falling under the scope of Regulation (EU) 2015/757 according to the ship's schedule",
        name: "minimumNumberOfVoyages",
        maxLength: 1000,
    },
    {
        label: "Are there expected voyages per reporting period not falling under the scope of Regulation (EU) 2015/757 according to the ship's schedule?",
        name: "expectedVoyagesUnderScope",
        type: "dropdown"
    },
    {
        label: "Conditions of Article 9(2) of Regulation (EU) 2015/757 fulfilled?",
        name: "regultionCondition",
        type: "dropdown"
    },
    {
        label: "If yes, do you intend to make use of the derogation for monitoring the amount of fuel consumed on a per-voyage basis. Please note that monitoring on a per-voyage basis of certain information may be required under Part C, point 2, of Annex II to Regulation (EU) 2015/757 to benefit from the derogation provided for in Articles 12(3-d) to 12(3-b) of Directive 2003/87/EC.",
        name: "useOfDerogation",
        type: "dropdown"
    },
]

// b4-section constants
export const gases = ["co2", "ch4", "n2o"];
export const frameworks = ["MRV", "ETS"];


//B1 payload
export const createB1Payload = (data = {}, mode, dropdownData) => {
    const technicalEfficiencyObject = dropdownData?.technicalEfficiencyCodes?.find((item) => {
        return item.technicalEfficiencyMstId === data?.VesselTechnicalEfficiencyDtls[0]?.TechnicalEfficiencyMstId;
    });
    return {
        shipName: mode === "Create" ? data.VesselName : data.shipName ?? "",
        imoNumber: mode === "Create" ? data.ImoNumber : data.imoNumber ?? "",
        portOfRegistry: mode === "Create" ? data.PortCodeMst?.PortName : data.portOfRegistry ?? "",
        homePort: data.homePort || "",
        shipOwnerName: data.shipOwnerName || "",
        shipOwnerTaxNumber: data.shipOwnerTaxNumber || "",
        shipOwnerContactPerson: data.shipOwnerContactPerson || "",
        businessAddress: data.businessAddress || "",
        city: data.city || "",
        stateProvinceRegion: data.stateProvinceRegion || "",
        businessTelephone: data.businessTelephone || "",
        businessEmail: data.businessEmail || "",
        registeredOwnerIMO: data.registeredOwnerIMO || "",
        registeredOwnerCountry: data.registeredOwnerCountry || "",
        shipType: mode === "Create" ? data?.MrvVesselTypeMst?.Code : data.shipType ?? "",
        shipSubType: data.shipSubType || "",
        deadweight:
            mode === "Create"
                ? data.DeadWeight || 0
                : data.deadweight !== undefined && data.deadweight !== "" && data.deadweight !== null
                    ? Number(data.deadweight)
                    : 0,
        grossTonnage:
            mode === "Create"
                ? data.GrossTonnage || 0
                : data.grossTonnage !== undefined && data.grossTonnage !== "" && data.grossTonnage !== null
                    ? Number(data.grossTonnage)
                    : 0,
        classificationSociety: data.classificationSociety || "",
        iceClass: mode === "Create" ? data?.IceClassMst?.Code : data.iceClass ?? "",
        isIceClassShip: mode === "Create" ? data.IceClassMstId ? true : false : data.isIceClassShip || false,
        flag: mode === "Create" ? data?.PortCodeMst?.CountryCode : data.flag || "",
        technicalEfficiency: mode === "Create" ? technicalEfficiencyObject?.code : data.technicalEfficiency ?? "",
        technicalEfficiencyValue:
            mode === "Create"
                ? data.technicalEfficiencyValue || 0
                : data.technicalEfficiencyValue !== undefined && data.technicalEfficiencyValue !== "" && data.technicalEfficiencyValue !== null
                    ? Number(data.technicalEfficiencyValue)
                    : 0,
        additionalInformation: data.additionalInformation || "",
        businessPrinciplePlace: data.businessPrinciplePlace || ""
    }
};

export const ALLOWED_SHIP_TYPES = [
    "Chemical tanker",
    "Bulk carrier",
    "Combination carrier",
];

export const REQUIRED_FIELDS_FOR_B2 = [
    "companyName",
    "companyNatures"
]

export const REQUIRED_FIELDS_FOR_B1 = [
    "shipName",
    "imoNumber",
    "shipOwnerName",
    "businessAddress",
    "registeredOwnerCountry",
    "flag",
    "shipType",
    "isIceClassShip",
    "iceClass"
]
export const tabs = ["MP PARTICULARS", "BASIC DATA", "ACTIVITY DATA", "DATA GAPS", "MANAGEMENT", "FURTHER INFORMATION"];
export const AUTOSAVE_SUCCESS_MESSAGE = "Your changes have been saved automatically."